<template>
  <v-container class="no-gutters" fluid>
    <!-- drawer -->

    <v-navigation-drawer v-model="drawer" absolute temporary fixed>
      <v-list-item>
        <v-list-item-avatar>
          <v-img
            src="https://aied.jp/wp-content/uploads/2021/05/aneta-pawlik-BBWmO2Xt-9s-unsplash-scaled.jpg"
          ></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Reference Text</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <div class="pa-4">
        Words
        <v-chip-group active-class="primary--text" column>
          <v-chip
            v-for="word in words"
            :key="word"
            @click="
              setWord(word.phn);
              setChivox(word.phn, word.phn, true);
            "
          >
            <div>{{ word.phn }}</div>
          </v-chip>
        </v-chip-group>
      </div>

      <div class="pa-4">
        Sentences
        <v-chip-group active-class="primary--text" column>
          <v-chip
            v-for="sentence in sentences"
            :key="sentence"
            @click="setChivox(sentence.phn, sentence.num, null)"
          >
            {{ sentence.num }}
          </v-chip>
        </v-chip-group>
      </div>
    </v-navigation-drawer>

    <!-- drawer  -->

    <v-app-bar
      absolute
      color="#fcb69f"
      dark
      shrink-on-scroll
      src="https://picsum.photos/1920/1080?random"
      scroll-target="#scrolling-techniques-2"
      height="80"
    >
      <template v-slot:img="{ props }">
        <v-img
          v-bind="props"
          gradient="to top right, rgba(19,84,122,.5), rgba(128,208,199,.8)"
        ></v-img>
      </template>

      <v-app-bar-nav-icon></v-app-bar-nav-icon>

      <v-app-bar-title>Chivox-demo</v-app-bar-title>

      <v-spacer></v-spacer>

      <v-btn icon>
        <v-icon></v-icon>
      </v-btn>

      <v-btn icon>
        <v-icon></v-icon>
      </v-btn>

      <v-btn class="d-flex d-sm-none" icon @click.stop="drawer = !drawer">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </v-app-bar>
    <v-sheet
      id="scrolling-techniques-2"
      class="overflow-y-auto"
      max-height="600"
    ></v-sheet>
    <!-- app-bar -->

    <v-row id="main-row" class="text-center mt-16 pa-10">
      <v-col cols="12" sm="7" justify="center" class="col-xs-12">
        <h1 class="display-2 font-weight-bold mb-3">
          {{ refText }}
        </h1>

        <p class="subheading font-weight-regular">
          <!-- <br>/audio/{{ audioUrl }}.mp3 -->
        </p>

        <div id="btn" style="height:50px;">
          <div>
            <v-btn fab id="r_play" class="pa-2 r_play" @click="play"
              ><v-icon>mdi-ear-hearing</v-icon></v-btn
            >
            <v-btn fab id="r_record" class="r_record pa-2 ma-2" @click="record"
              ><v-icon>mdi-microphone</v-icon></v-btn
            >
            <v-btn fab id="r_replay" class="pa-2 r_replay" @click="replay"
              ><v-icon>mdi-headset</v-icon></v-btn
            >
          </div>
        </div>
        <div id="chivox-recorder"></div>

        <v-row justify="center" class="mt-15">
          <v-sheet
            class="text-center"
            justify="center"
            align-content="center"
            elevation="0"
            rounded="lg"
            width="380"
            height="300"
            :align-self="align"
            align="center"
          >
            <p
              v-if="result"
              transition="slide-y-transition"
              class="scoreResult"
            >
              <v-row justify="center" class="mt-3">
                <i v-bind:class="first_star" class="first_star star"></i>
                <i v-bind:class="second_star" class="second_star star"></i>
                <i v-bind:class="third_star" class="third_star star"></i>
              </v-row>

              <v-row justify="" class="mt-6 fade">
                <v-col cols="4">
                  <v-chip class="blue darken-1 white--text mr-1"
                    ><span class="">総合点</span></v-chip
                  ><br />
                  <div class="mt-2 font-weight-bold grey--text text--darken-3">
                    {{ overall }} 点
                  </div>
                </v-col>

                <v-col cols="4">
                  <v-chip class="blue darken-1 white--text mr-1">発音点</v-chip
                  ><br />
                  <div class="mt-2 font-weight-bold grey--text text--darken-3">
                    {{ pron }} 点
                  </div>
                </v-col>

                <v-col cols="4">
                  <v-chip class="blue darken-1 white--text mr-1">流暢さ</v-chip
                  ><br />
                  <div class="mt-2 font-weight-bold grey--text text--darken-3">
                    {{ fluency }} 点
                  </div>
                </v-col>
              </v-row>
            </p>
          </v-sheet>
        </v-row>
      </v-col>

      <v-col cols="5">
        <v-col cols="12" sm="12" md="12" lg="12" class="d-none d-sm-flex">
          <v-sheet elevation="10" rounded="xl">
            <v-sheet
              class="pa-3 indigo darken-2 text-center"
              dark
              rounded="t-xl"
            >
              <h4>Words</h4>
            </v-sheet>

            <div class="pa-4">
              <v-chip-group active-class="primary--text" column>
                <v-chip
                  v-for="word in words"
                  :key="word"
                  @click="setChivox(word.phn, word.phn, true)"
                >
                  <div>{{ word.phn }}</div>
                </v-chip>
              </v-chip-group>
            </div>
          </v-sheet>
        </v-col>

        <v-col cols="12" sm="12" md="12" lg="12" class="d-none d-sm-flex">
          <v-sheet elevation="10" rounded="xl">
            <v-sheet class="pa-3 cyan darken-2 text-center" dark rounded="t-xl">
              <h4>Sentences</h4>
            </v-sheet>

            <div class="pa-4">
              <v-chip-group active-class="primary--text" column>
                <v-chip
                  v-for="sentence in sentences"
                  :key="sentence"
                  @click="setChivox(sentence.phn, sentence.num, null)"
                >
                  {{ sentence.num }}
                </v-chip>
              </v-chip-group>
            </div>
          </v-sheet>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/jquery/2.1.3/jquery.min.js"></script>
<script
  type="text/javascript"
  src="https://sdk.cloud.chivox.com/chivoxsdk-js/v6.0/chivox.min.js"
></script>

<script>
//初期化

var player = new Html5Player();
var recorder = new Html5Recorder({
  server: "wss://cloud.chivox.com",
  appKey: "171565128200015c",
  sigurl: "https://aied.xsrv.jp/sig.php",
  onInit: function(mess) {
    console.log("onInit success");
    $("#r_play").click();
    $("#r_replay").click();
    $("#r_record").click();
  },
  onError: function(err) {
    console.log("onError:" + err);
  },
});

let playStatus = true;
let recordFlag = true;
let replayFlag = true;

let refText = "apple";
let audioUrl = "apple";
// let wordList = ["ae"];
let wordCore = true;

// fontawesome
const star_fil = "fas fa-star fa-2x";
const star_half = "fas fa-star-half-alt fa-2x mx-1";
const star_blank = "far fa-star fa-2x";

let scoreResult = "";

let overall = 0;
let pron = 0;
let fluency = 0;

let vueData = "";

// let result = false;

export default {
  name: "Training",
  data() {
    return {
      drawer: null,
      phone: "a",
      refText: "apple",
      // wordList: ["ae"],
      audioUrl: "apple",
      result: false,
      first_star: "star_blank",
      second_star: "star_blank",
      third_star: "star_blank",
      words: [
        { phn: "apple" },
        { phn: "book" },
        { phn: "dog" },
        { phn: "egg" },
        { phn: "fabric" },
        { phn: "great" },
        { phn: "high" },
        { phn: "interesting" },
        { phn: "jacket" },
        { phn: "kick" },
        { phn: "lion" },
        { phn: "moment" },
        { phn: "option" },
        { phn: "quick" },
        { phn: "radio" },
        { phn: "soon" },
        { phn: "together" },
        { phn: "wall" },
        { phn: "box" },
        { phn: "zoo" },
      ],
      sentences: [
        { phn: "I can't agree with you more.", num: "1" },
        { phn: "He's such a great teacher.", num: "2" },
        { phn: "What a great idea is that!", num: "3" },
        { phn: "Do you have any questions?", num: "4" },
        { phn: "If you forget your password, please let us know.", num: "5" },
      ],
      // duration: 1000,
    };
  },
  methods: {
    setChivox: function(refT, audio, wordFlag) {
      this.result = false;
      refText = refT;
      audioUrl = audio;
      if (wordFlag !== null) {
        wordCore = true;
      } else {
        wordCore = false;
      }
      this.refText = refT;
      this.audioUrl = refT;
    },
    setWord: function(phn) {
      this.phone = phn;
      this.result = false;
    },
    setResult: function() {
      this.scoreResult = "B";
    },
    noWordlist: function() {
      phonics = false;
    },
    test: function() {
      let self = this;
      // console.log("test" + self.overall);
    },
    displayResult: function() {
      // console.log("countStars");
      // console.log(scoreResult.result.overall);
      // console.log(scoreResult.result.pron);
      if (scoreResult.result.fluency) {
        // console.log(scoreResult.result.fluency.overall);
      }
      // console.log(scoreResult.result);

      vueData.first_star = star_blank;
      vueData.second_star = star_blank;
      vueData.third_star = star_blank;

      vueData.overall = scoreResult.result.overall;
      vueData.pron = scoreResult.result.pron;
      if (scoreResult.result.fluency) {
        vueData.fluency = scoreResult.result.fluency.overall;
      } else {
        vueData.fluency = "--";
      }

      if (scoreResult.result.overall > 10) {
        vueData.first_star = star_fil;
        if (scoreResult.result.overall > 49) {
          vueData.second_star = star_half;
          if (scoreResult.result.overall > 74) {
            vueData.second_star = star_fil;
            if (scoreResult.result.overall > 84) {
              vueData.third_star = star_half;
              if (scoreResult.result.overall > 94) {
                vueData.third_star = star_fil;
              }
            }
          }
        }
      }
    },
    evaltest: function() {
      this.result = true;
      this.displayResult();
    },
    play: function() {
      $(".r_play").click(function() {
        if (playStatus) {
          playStatus = false;
          // console.log(player);
          player.setVolume(0.9); /*设置播放音频音量大小 0~1 */
          player.load({
            url: `../audio/chivox_demo/${audioUrl}.mp3`,
            success: function() {
              console.log("player start success.");
              player.play({
                position: 0, //播放位置
                duration: 4000, //播放时长
                onStop: function() {
                  playStatus = true;
                  console.log("player onStop");
                  /*获取当前播放音频的音量，精度与设置的有出入*/
                  console.log("Volume:" + player.getVolume());
                },
                onStart: function() {
                  console.log("player onStart");
                },
                error: function(err) {
                  console.log(err);
                },
              });
            },
            error: function(err) {
              playStatus = true;
              player.stop(); /*手动停止音频播放*/
              player.reset(); /*重置播放器状态*/
              console.log("player error:" + JSON.stringify(err));
            },
          });
        } else {
          playStatus = true;
          player.stop();
        }
      });
    },
    record: function() {
      // let self = this;
      vueData = this;

      $("#r_record").click(function() {
        $("#r_record").css("color", "crimson");
        if (recordFlag) {
          recordFlag = false;
          // recorder.showVolumeBar();/*显示波形图*/
          // console.log("this refText: " + self.refText);
          // console.log("refText: " + refText);
          // recorder.showVolumeBar();
          recorder.stopRecord();
          if (wordCore) {
            console.log("en.word.score");
            recorder.record({
              duration: 1500,
              playDing: true,
              audioType: "mp3",
              serverParams: {
                coreType: "en.word.score",
                refText: refText,
                rank: 100,
                userId: "tester",
                attachAudioUrl: 1,
              },
              onRecordIdGenerated: function(tokenId) {
                console.log("========onRecordIdGenerated start========");
                var lastTokenID = tokenId.tokenId;
                console.log(JSON.stringify(tokenId));
                console.log("========onRecordIdGenerated end========");
              },
              onStart: function() {
                console.log("onStart");
                vueData.result = false;
                vueData.first_star = star_blank;
                vueData.second_star = star_blank;
                vueData.third_star = star_blank;
              },
              onStop: function() {
                console.log("onStop");
              },
              onScore: function(score) {
                vueData.result = true;
                scoreResult = score;
                vueData.displayResult();

                recordFlag = true;
                vueData.result = true;
                recorder.stopRecord();
                console.log("overall: " + score.result.overall);
                $("#r_record").css("color", "black");
                $("#r_record").blur();
              },
              onScoreError: function(err) {
                recordFlag = true;
                recorder.stopRecord();
                recorder.reset();
                alert(
                  "回線が混み合っています。しばらく経ってからお試しください。"
                );
                $("#r_record").css("color", "black");
                $("#r_record").blur();
              },
            });
          } else {
            console.log("en.sent.score");
            recorder.record({
              duration: 4000,
              // playDing: true,
              audioType: "mp3",
              serverParams: {
                coreType: "en.sent.score",
                refText: refText,
                rank: 100,
                userId: "tester",
                attachAudioUrl: 1,
              },
              onRecordIdGenerated: function(tokenId) {
                console.log("========onRecordIdGenerated start========");
                var lastTokenID = tokenId.tokenId;
                console.log(JSON.stringify(tokenId));
                console.log("========onRecordIdGenerated end========");
              },
              onStart: function() {
                console.log("onStart");
                vueData.result = false;
                vueData.first_star = star_blank;
                vueData.second_star = star_blank;
                vueData.third_star = star_blank;
              },
              onStop: function() {
                console.log("onStop");
                $("#r_record").css("color", "black");
                $("#r_record").blur();
              },
              onScore: function(score) {
                vueData.result = true;
                scoreResult = score;
                vueData.displayResult();

                recordFlag = true;
                vueData.result = true;
                recorder.stopRecord();
                console.log("overall: " + score.result.overall);
                $("#r_record").css("color", "black");
                $("#r_record").blur();
              },
              onScoreError: function(err) {
                recordFlag = true;
                recorder.stopRecord();
                recorder.reset();
                alert(
                  "回線が混み合っています。しばらく経ってからお試しください。"
                );
                $("#r_record").css("color", "black");
                $("#r_record").blur();
              },
            });
          }
        } else {
          recordFlag = true;
          recorder.stopRecord();
          console.log("record stop!");
        }
      });
    },
    replay: function() {
      $(".r_replay").click(function() {
        if (replayFlag) {
          replayFlag = false;
          recorder.startReplay({
            onStop: function() {
              replayFlag = true;
              console.log("startReplay");
            },
          });
        } else {
          replayFlag = true;
          recorder.stopReplay();
        }
      });
    },
    stopRecording: function() {
      // console.log(player);
      // console.log(recorder);

      playStatus = true;
      player.stop();
      player.reset();

      recordFlag = true;
      recorder.stopRecord();
      recorder.reset();
    },
  },
};
</script>
